import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './AnalyticsTabs.css';

const ANALYTICS_TABS = [
  {
    key: 'reportes',
    label: 'Reportes',
    section: 'estadisticas-reportes',
  },
  {
    key: 'clientes',
    label: 'Clientes',
    section: 'estadisticas-clientes',
  },
  {
    key: 'proveedores',
    label: 'Proveedores',
    section: 'estadisticas-proveedores',
  },
];

const AnalyticsTabs = () => {
  const location = useLocation();

  const tabs = useMemo(() => {
    const isDashboard = location.pathname === '/dashboard';
    const sectionParam = isDashboard ? new URLSearchParams(location.search).get('section') : '';
    return ANALYTICS_TABS.map(tab => {
      const href = `/dashboard?section=${tab.section}`;
      const isActive = isDashboard && sectionParam === tab.section;
      return { ...tab, href, isActive };
    });
  }, [location]);

  return (
    <nav className="analytics-tabs" aria-label="Secciones de estadísticas">
      <div className="analytics-tabs__container">
        {tabs.map(tab => (
          <Link
            key={tab.key}
            to={tab.href}
            className={`analytics-tabs__item${tab.isActive ? ' is-active' : ''}`}
            aria-current={tab.isActive ? 'page' : undefined}
          >
            {tab.label}
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default AnalyticsTabs;
